import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { IconButton } from "@aviary";
import type { SocialMenuLink } from "@unauthenticated/catalog/data/MenuLinks.types";

import * as styles from "./SocialLinks.styles";

interface Props {
  links: SocialMenuLink[];
}

const SocialLinks: FC<Props> = ({ links }) => {
  const { t } = useTranslation();

  const renderLinks = () => {
    return links.map((link, i) => (
      <li key={i}>
        <IconButton
          href={link.link}
          isCircular
          target="_blank"
          rel="noopener noreferrer"
          isColor="system"
          isSize="xsmall"
          aria-label={t(link.label)}
        >
          <FontAwesomeIcon icon={link.icon} size="sm" />
        </IconButton>
      </li>
    ));
  };

  return (
    <div css={styles.socialLinksWrapper}>
      <ul css={styles.socialLinks}>{renderLinks()}</ul>
    </div>
  );
};

export { SocialLinks };
